import { MaintenanceUserRole } from './MaintenanceUserRole';

export class MaintenanceUser {
  public id: number | undefined;
  public gmin: string = "";
  public nombre: string = "";
  public apellido: string = "";
  public role: MaintenanceUserRole = new MaintenanceUserRole();
  public estado: boolean = true;
  public usrCreacion: string = "";
  public fecCreacion: Date = new Date();
  public usrModif: string | undefined;
  public fecModif: Date | undefined;


  /**
   * This maps the data obj received from http client, which
   * contains userId as a number, to a User.ts obj with userId
   * as a string for compatibility with our column filters.
   * @param data The data received from HttpClient.
   */
  static transformUser(data: any): MaintenanceUser {
    let user = new MaintenanceUser();
    user.id = data.id;
    user.gmin = data.gmin.toString();
    user.nombre = data.nombre;
    user.apellido = data.apellido;
    user.role = data.role;
    user.estado = data.estado;
    user.usrCreacion = data.usrCreacion;
    user.fecCreacion = new Date(data.fecCreacion);

    if (data.usrModif != undefined) {
      user.usrModif = data.usrModif;
    }
    if (data.fecModif !== undefined) {
      user.fecModif = new Date(data.fecModif);
    }

    return user;
  }

}
